<template>
  <div v-if="qacategory !== null">
    <!-- 分類[Warranty & FAQ & RMA] -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="qacategory.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="qacategory.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- QA 群組[Warranty or FAQ or RMA...] -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>群組</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="qacategory.support_categories_id"
            :items="supportcates"
            placeholder="請選擇所屬群組"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="qacategory.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="qacategory.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="qacategory.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    FormSwitch,
  },
  data: () => ({
    tab: '',
    status: true,
    bu: [],
    supportcates: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState(['buTabs']),
    ...mapState('qacategory', ['qacategory']),
  },
  async created() {
    if (this.qacategory.support_categories_id !== null) {
      this.supportcates = await this.getSupportQACates(this.qacategory.support_categories_id);
    }
  },
  watch: {
    async 'qacategory.support_categories_id'(newValue) {
      if (newValue !== '') {
        this.supportcates = await this.getSupportQACates(newValue);
      } else {
        this.supportcates = [];
      }
    },
  },
  methods: {
    ...mapActions('qacategory', ['getSupportQACates']),
  },
};
</script>

<style></style>
